import { apiClient } from './client'
import endpoints from './endpoints'
import { unwrapCollection } from './normalize'

export type Program = { id: string | number; name: string; [key: string]: unknown }

export default async function getProgram({
  id,
  signal,
}: {
  id: string | number
  signal?: AbortSignal
}): Promise<Program | null> {
  const response = await apiClient.get(endpoints.programs, { params: { id }, signal })
  return unwrapCollection<Program>(response)[0] ?? null
}
